import { useCallback } from "react";

import { useGetLocationsQuery } from "../requests/transport.queries";

export const useLocations = () => {
    const { data: locations, isFetching: loading } = useGetLocationsQuery();

    const isStringAirport = useCallback(
        (string: string): boolean => {
            return locations.some(
                (location) => location.isAirport && location.name.toUpperCase() === string.toUpperCase()
            );
        },
        [locations]
    );

    return {
        locations,
        loading,
        isStringAirport,
    };
};
